import React from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

import Drawer from '@material-ui/core/Drawer';
import { withStyles } from '@material-ui/core/styles';
import { CardText } from 'material-ui/Card';
import Card from '@material-ui/core/Card';

import FooterButtons from 'components/shared/FooterButtons';

import LogDetails from './LogDetails';

const StyledDrawer = withStyles({
  paperAnchorLeft: { maxWidth: '550px', width: '100% !important' },
  background: '#fbfbfb',
})(Drawer);

const style = {
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Questrial", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    marginBottom: '25px',
  },
  header: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    margin: '8px 0px',
  },
  headerContainer: {
    width: '100%',
    height: '65px',
    padding: '10px',
    textAlign: 'center',
  },
};

class LogsDrawer extends React.Component {
  render() {
    return (
      <StyledDrawer open={this.props.open} onClose={this.toggleOpen} anchor="left">
        <div className="row" style={style.headerContainer}>
          <h2 style={style.header}>
            {this.props.data.title}
            &nbsp;
            {this._renderStatus()}
          </h2>
        </div>

        <div style={{ padding: '15px' }}>
          <Card style={style.transactionCard}>
            <CardText expandable style={{ padding: '0 0 10px' }}>
              <LogDetails log={this.props.data} />
            </CardText>
          </Card>
        </div>

        <FooterButtons
          backName="Close"
          backAction={this.props.toggleOpen}
          submitAction={() => this.props.createOrUpdateLog(this.props.data)}
          submitName={this.props.data.read ? 'Mark as unread' : 'Mark as read'}
          disableSubmitOverride
        />
      </StyledDrawer>
    );
  }

  _renderStatus = () => {
    const [css, text] = this.props.data.read ? ['inactive', 'Read'] : ['closed', 'Unread'];

    return (
      <span>
        <span className={`ticket_status_label_title small ${css}`} style={{ fontSize: '35%' }}>
          {text}
        </span>
      </span>
    );
  };
}

export default connect(null, { submit })(LogsDrawer);
